/* ============================================================
   PetJojo — cart drawer upsell: pagination dots + placement
   ------------------------------------------------------------
   Two jobs, both of which need JS rather than CSS:

   1. DOTS. The number of suggestions is only known once Shopify's
      recommendations have been fetched, so the markup cannot carry a fixed set
      of dots. cart.js also replaces the panel's innerHTML wholesale on every
      cart update, which destroys anything built here — hence the observer
      below rather than a one-shot build on load.

   2. PLACEMENT. On mobile the panel is rendered inside the scrolling item list,
      so it sits below the cart contents and scrolls away. It belongs directly
      above the subtotal. It cannot be moved with CSS order (it is nested inside
      cart-drawer-items, while the subtotal lives in .drawer__footer), and it is
      not moved in Liquid because on desktop the panel is position:absolute and
      relies on its current ancestor for its containing block.

   Desktop is left exactly as the theme renders it.
   ============================================================ */
(function () {
  var MOBILE = '(max-width: 767px)';
  var mq = window.matchMedia(MOBILE);
  var HOME_ATTR = 'data-pj-upsell-home';

  function panel() {
    return document.querySelector('.cart-drawer-recommendations');
  }

  /* ---------- placement ---------- */
  /* The panel is left exactly where the theme renders it: at the END of the
     scrolling item list.

     It was briefly pinned into the footer, directly above the subtotal. With a
     single cart item that looked right, but the footer is fixed — so with two or
     more items the pinned card ate the space the cart itself needed and covered
     the products. Cart contents come first; the suggestion scrolls up after
     them. Any marker left by that behaviour is cleaned up here. */
  function place() {
    var stale = document.querySelector('[' + HOME_ATTR + ']');
    if (!stale) return;
    var p = panel();
    if (p && stale.parentElement && p.parentElement !== stale.parentElement) {
      stale.parentElement.insertBefore(p, stale);
    }
    stale.remove();
  }

  /* ---------- dots ---------- */
  /* Measure each card's own offset instead of assuming page = container width:
     the rail has a gap between cards, so card N starts at N * (width + gap) and
     dividing by the width alone drifts out of step by one gap per card. */
  function offsets(list) {
    var base = list.getBoundingClientRect().left;
    return [].map.call(list.querySelectorAll('.cart__row'), function (s) {
      return s.getBoundingClientRect().left - base + list.scrollLeft;
    });
  }

  function currentIndex(list) {
    var offs = offsets(list);
    var x = list.scrollLeft;
    var best = 0;
    var bestD = Infinity;
    for (var i = 0; i < offs.length; i++) {
      var d = Math.abs(offs[i] - x);
      if (d < bestD) { bestD = d; best = i; }
    }
    return best;
  }

  function paint(dots, list) {
    var i = currentIndex(list);
    for (var d = 0; d < dots.children.length; d++) {
      dots.children[d].setAttribute('aria-current', d === i ? 'true' : 'false');
    }
  }

  function dotsFor(p) {
    var list = p.querySelector('.cart-drawer-recommendations__list');
    if (!list) return;
    var slides = list.querySelectorAll('.cart__row');
    var dots = p.querySelector('.pj-upsell-dots');

    // A single suggestion is not a carousel.
    if (!mq.matches || slides.length < 2) {
      if (dots) dots.remove();
      return;
    }

    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'pj-upsell-dots';
      list.parentNode.insertBefore(dots, list.nextSibling);
    }

    if (dots.children.length !== slides.length) {
      dots.textContent = '';
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Suggestion ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener(
          'click',
          (function (idx) {
            return function () {
              var offs = offsets(list);
              list.scrollTo({ left: offs[idx] || 0, behavior: 'smooth' });
            };
          })(i)
        );
        dots.appendChild(b);
      }
    }

    if (!list.pjBound) {
      list.pjBound = true;
      var ticking = false;
      list.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var d = p.querySelector('.pj-upsell-dots');
            if (d) paint(d, list);
          });
        },
        { passive: true }
      );
    }

    paint(dots, list);
  }

  /* ---------- note state ----------
     The drawer carries .pj-note-open, which hides the subtotal + CHECKOUT while
     a note is being written. That class cannot be driven by clicks alone: on a
     successful save cart.js waits 1700ms and then calls closeFooterModal()
     itself, which clears .open on the panel but knows nothing about our class —
     so the subtotal stayed hidden and the drawer looked frozen with no way back.

     Mirroring the panel's actual .open state means every route out (our toggle,
     the CLOSE button, a save, a re-render) lands in a consistent UI. */
  /* Whether a note is actually stored. The textarea is rendered from cart.note,
     and the theme's CLOSE restores the pre-edit value, so its current value is
     the saved value — no extra request needed. */
  function hasNote() {
    var ta = document.querySelector('#Cart-note');
    return !!(ta && ta.value.trim());
  }

  function syncNoteState() {
    var drawer = document.querySelector('.pj-drawer');
    if (!drawer) return;
    var modal = drawer.querySelector('.cart__footer-modal');
    var open = !!(modal && modal.classList.contains('open'));
    // Only write when it actually differs — this runs from an attribute
    // observer, and an unconditional write would retrigger it forever.
    if (drawer.classList.contains('pj-note-open') !== open) {
      drawer.classList[open ? 'add' : 'remove']('pj-note-open');
    }
    var t = drawer.querySelector('.pj-note-toggle');
    if (!t) return;
    if (t.getAttribute('aria-expanded') !== String(open)) {
      t.setAttribute('aria-expanded', String(open));
    }

    /* The filled radio means "you have a note", not "the panel is open" — after
       saving, the panel closes and the shopper needs to see that the note stuck.
       Guarded write: this runs from a class observer. */
    var saved = hasNote();
    if (t.classList.contains('pj-has-note') !== saved) {
      t.classList[saved ? 'add' : 'remove']('pj-has-note');
    }

    var label = t.querySelector('[data-pj-note-label]');
    if (label) {
      var next = saved
        ? label.getAttribute('data-label-added')
        : label.getAttribute('data-label-default');
      if (next && label.textContent !== next) label.textContent = next;
    }
  }

  /* ---------- run ---------- */
  var queued = false;
  function sync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var p = panel();
      if (!p) return;
      place();
      dotsFor(p);
    });
  }

  function start() {
    sync();
    var root = document.querySelector('cart-drawer') || document.body;
    // The panel is re-rendered (innerHTML replaced) on every cart update, and
    // the drawer itself can be re-rendered too, so watch the subtree rather
    // than binding to any one node.
    syncNoteState();
    new MutationObserver(function () {
      syncNoteState();
      sync();
    }).observe(root, {
      childList: true,
      subtree: true,
      // .open is toggled as a CLASS, so childList alone never sees a save close
      // the panel.
      attributes: true,
      attributeFilter: ['class'],
    });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    window.addEventListener('resize', sync, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /* ---------- single notes control ---------- */
  /* ONE field, not two. The sheet holds three panels — the order note, the gift
     note, and the shipping estimator — and only the order note is opened.
     It is the one that writes cart.note (the gift note writes a separate cart
     attribute), so a single field posting to cart.note carries whatever the
     shopper types, whether that is delivery instructions or a gift message. The
     field's label says as much.

     openFooterModal() also does the value + character-count bookkeeping for the
     panel it is handed, so it stays in charge of opening. */
  window.pjOpenNotes = function (el) {
    var host = el.closest('cart-footer-modal');
    if (!host || !host.querySelector('.cart__footer-modal__cart-note')) return;

    // Same control closes it: the panel now sits inline under this row, so the
    // row is what the shopper looks at to see whether a note is open.
    var drawer = el.closest('.pj-drawer');
    var modal = host.querySelector('.cart__footer-modal');
    if (modal && modal.classList.contains('open')) {
      host.closeFooterModal('cart-note');
      el.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.classList.remove('pj-note-open');
      return;
    }

    host.openFooterModal('cart-note');
    el.setAttribute('aria-expanded', 'true');
    // Hides the subtotal + CHECKOUT while the note has focus (CSS).
    if (drawer) drawer.classList.add('pj-note-open');
    // Bring the field into view when the footer grows around it.
    var ta = host.querySelector('.cart__footer-modal__cart-note textarea');
    if (ta && ta.scrollIntoView) {
      requestAnimationFrame(function () {
        ta.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  };

  /* The theme's close button clears .open but leaves our control marked open. */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[onclick*="closeFooterModal"]');
    if (!closer) return;
    var t = document.querySelector('.pj-note-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
    var dr = document.querySelector('.pj-drawer');
    if (dr) dr.classList.remove('pj-note-open');
  });
})();
